// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tvp-proview_root .tvp-divDrag {
  display: flex;
  flex-direction: column;
  z-index: 10;
}
.tvp-proview_root #tvp_recorder_container_holder {
  width: 120px;
  height: 80px;
  position: absolute;
  top: -80px;
}
.tvp-proview_root .tvp-sharedSreen {
  display: flex;
  flex-direction: column;
  z-index: 21111;
}
.tvp-proview_root #sharedIcon {
  display: flex;
  flex-direction: row;
  z-index: 22222;
  border-radius: 20.5px;
  background: transparent;
  width: -moz-fit-content;
  width: fit-content;
  padding: 2px;
  align-items: center;
  justify-content: center;
  height: 45px;
}
.tvp-proview_root #sharedIcon svg {
  width: 30px;
  height: 30px;
  margin: 2px;
  z-index: 33333;
  cursor: pointer;
}
.tvp-proview_root #tvp_recorder_container {
  z-index: 23333;
}
.tvp-proview_root #tvp_recorder_holder {
  z-index: 99999999 !important;
}
.tvp-proview_root .tvp-sharedSreen {
  z-index: 21111;
}
.tvp-proview_root #tvp_recorder_container_holder,
.tvp-proview_root .tvp-sharedIcon {
  z-index: 22222;
}
.tvp-proview_root .tvp-sharedIcon > div {
  z-index: 23333;
  cursor: none;
}
.tvp-proview_root .tvp-button-no-border {
  border: none;
}
.tvp-proview_root .tvp-external-link-icon {
  cursor: pointer;
  text-align: center;
  border-radius: 30px;
  margin-right: auto;
  margin-left: auto;
  color: white;
  padding: 4px;
  background-color: #0284c7;
}

.tvp-proview_root .tvp-recorder-holder {
  background: transparent;
  position: fixed;
}

.tvp-proview_root .tvp-isVisible {
  opacity: 100;
}

.tvp-proview_root .tvp-isHidden {
  opacity: 0;
}

.tvp-proview_root .tvp-video-icon {
  cursor: pointer;
  text-align: center;
  border-radius: 30px;
  margin-right: auto;
  margin-left: auto;
  color: white;
  padding: 4px;
  background-color: #db7093;
}

.tvp-proview_root .tvp-chat-icon {
  cursor: pointer;
  text-align: center;
  border-radius: 30px;
  margin-right: auto;
  margin-left: auto;
  color: white;
  padding: 4px;
  background-color: #34d399;
}

.tvp-proview_root .tvp-draggable-hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/layouts/dragable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".tvp-proview_root .tvp-divDrag {\n  display: flex;\n  flex-direction: column;\n  z-index: 10;\n}\n.tvp-proview_root #tvp_recorder_container_holder {\n  width: 120px;\n  height: 80px;\n  position: absolute;\n  top: -80px;\n}\n.tvp-proview_root .tvp-sharedSreen {\n  display: flex;\n  flex-direction: column;\n  z-index: 21111;\n}\n.tvp-proview_root #sharedIcon {\n  display: flex;\n  flex-direction: row;\n  z-index: 22222;\n  border-radius: 20.5px;\n  background: transparent;\n  width: fit-content;\n  padding: 2px;\n  align-items: center;\n  justify-content: center;\n  height: 45px;\n}\n.tvp-proview_root #sharedIcon svg {\n  width: 30px;\n  height: 30px;\n  margin: 2px;\n  z-index: 33333;\n  cursor: pointer;\n}\n.tvp-proview_root #tvp_recorder_container {\n  z-index: 23333;\n}\n.tvp-proview_root #tvp_recorder_holder {\n  z-index: 99999999 !important;\n}\n.tvp-proview_root .tvp-sharedSreen {\n  z-index: 21111;\n}\n.tvp-proview_root #tvp_recorder_container_holder,\n.tvp-proview_root .tvp-sharedIcon {\n  z-index: 22222;\n}\n.tvp-proview_root .tvp-sharedIcon > div {\n  z-index: 23333;\n  cursor: none;\n}\n.tvp-proview_root .tvp-button-no-border {\n  border: none;\n}\n.tvp-proview_root .tvp-external-link-icon {\n  cursor: pointer;\n  text-align: center;\n  border-radius: 30px;\n  margin-right: auto;\n  margin-left: auto;\n  color: white;\n  padding: 4px;\n  background-color: #0284c7;\n}\n\n.tvp-proview_root .tvp-recorder-holder {\n  background: transparent;\n  position: fixed;\n}\n\n.tvp-proview_root .tvp-isVisible {\n  opacity: 100;\n}\n\n.tvp-proview_root .tvp-isHidden {\n  opacity: 0;\n}\n\n.tvp-proview_root .tvp-video-icon {\n  cursor: pointer;\n  text-align: center;\n  border-radius: 30px;\n  margin-right: auto;\n  margin-left: auto;\n  color: white;\n  padding: 4px;\n  background-color: #db7093;\n}\n\n.tvp-proview_root .tvp-chat-icon {\n  cursor: pointer;\n  text-align: center;\n  border-radius: 30px;\n  margin-right: auto;\n  margin-left: auto;\n  color: white;\n  padding: 4px;\n  background-color: #34d399;\n}\n\n.tvp-proview_root .tvp-draggable-hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
